<template>
  <div class="cmp-main-photo">
    <el-upload class="uploader g-inline-block mb-30" :action="'/singleMuseum/attach/upload'" accept="image/*" :show-file-list="false" multiple :data="configData" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess" v-if="showUpload && showMainBtn" list-type="picture">
      <a class="uploader-btn"></a>
    </el-upload>

    <viewer :images="viewFileList">
      <el-row :gutter="10" class="collect-img-row">
        <el-col class="item mb-20 g-pointer" :span="showMainBtn ? 8 : 3" v-for="(item, index) in viewFileList" :key="index">
          <div class="collect-img" :class="{'mini': !showMainBtn}">
            <img :src="item.attPath" alt>
            <el-button size="mini" class="img-btn img-btn-first" v-if="index===0 && showMainBtn">主图</el-button>
            <el-button type="primary" size="small" class="img-btn" v-if="index>0 && showUpload && showMainBtn" @click="setPhotoToMain(index)">设为主图</el-button>
            <span class="icon-close g-pointer" v-if="showUpload" @click="removePhoto(index)">
              <svg-icon icon-class="close" v-if="index!==0 || !showMainBtn" />
            </span>
          </div>
        </el-col>

        <!-- 首页-发动态 -->
        <el-col :span="3" v-if="!showMainBtn&&businessType!=='digital'">
          <el-upload class="uploader g-inline-block mb-30" :action="'/singleMuseum/attach/upload'" :fileList="fileList" accept="image/*" :show-file-list="false" multiple :data="configData" :limit="limit" :on-exceed="handleExceed" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess" v-if="showUpload" list-type="picture">
            <a class="uploader-btn"></a>
          </el-upload>
        </el-col>

        <!-- 数字资产-水印 -->
        <el-col :span="3" v-if="!showMainBtn&&businessType==='digital'">
          <el-upload class="uploader g-inline-block mb-30" :action="'/singleMuseum/attach/upload'" accept="image/*" :show-file-list="false" multiple :data="configData" :limit="limit" :on-exceed="handleExceed" :file-list="fileList" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccess" v-if="showUpload" list-type="picture">
            <a class="uploader-btn"></a>
          </el-upload>
        </el-col>
      </el-row>
    </viewer>
  </div>
</template>

<script>
export default {
  props: {
    // 所属业务名 collect	藏品模块 project	项目模块 digital	数字资产模块 workflow	审批流模块
    businessType: {
      type: String,
      default: 'collect' // 默认藏品
    },
    limit: {
      type: Number,
      default: 6
    },
    // 图片显示位置
    loc: {
      type: String,
      default: '' // 'left' 图片显示在按钮左边，  '' 默认显示在按钮下面
    },
    // 是否显示主图、设为主图按钮
    showMainBtn: {
      type: Boolean,
      default: true
    },
    // 显示上传控件
    showUpload: {
      type: Boolean,
      default: true
    },
    // 初始化文件列表
    fileList: {
      type: Array,
      default() {
        return []
      }
    },
    // getId: Function,
    // getItem: Function,
    callFun: Function
  },
  watch: {
    fileList() {
      this.viewFileList = this.fileList
    }
  },
  // computed: {
  //   viewFileList: {
  //     get() {
  //       return this.fileList
  //     },
  //     set(val) {
  //       console.log(val)
  //     }
  //   }
  // },
  data() {
    return {
      configData: {
        tableName: this.businessType
      },
      viewFileList: this.fileList
    }
  },
  methods: {
    init() {
      // this.viewFileList = this.fileList
    },
    // 设为主图
    setPhotoToMain(index) {
      this.viewFileList.unshift(this.viewFileList.splice(index, 1)[0])
      this.sentCallback(this.viewFileList)
    },
    // 移除
    removePhoto(index) {
      this.viewFileList.splice(index, 1)
      this.sentCallback(this.viewFileList)
    },
    // handleExceed(files, fileList) {
    handleExceed() {
      this.$message.warning('最多上传' + this.limit + '张图片')
      // this.$message.warning(
      //   `当前限制选择 3 个文件，本次选择了 ${
      //     files.length
      //   } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      // )
    },
    // 上传
    beforeAvatarUpload(file) {
      // let fd = new FormData()
      // fd.append('file', file)
      // fd.append('tableName', this.businessType) // 所属业务名
      // this.$http.post('attach/upload', fd).then(res => {
      //   if (res.success) {
      //     // this.$message.success('上传成功')
      //     this.viewFileList.push(res.result)
      //     this.sentCallback(this.viewFileList)
      //   } else {
      //     this.$message.error(res.message)
      //   }
      // })
      // return true
    },
    handleAvatarSuccess(res) {
      if (res.success) {
        // this.$message.success('上传成功')

        this.viewFileList.push(res.result)
        this.sentCallback(this.viewFileList)
      } else {
        this.$message.error(res.message)
      }
    },
    // 回调
    sentCallback(viewFileList) {
      let arr = []
      viewFileList.forEach(item => {
        arr.push(item.attId)
      })
      this.callFun && this.callFun(arr.join(','), viewFileList)
    }
  }
}
</script>

<style lang="scss" scoped>
.cmp-main-photo {
  .uploader {
    .uploader-img {
      width: 100px;
      height: 100px;
    }
    .uploader-btn {
      display: inline-block;
      width: 100px;
      height: 100px;
      background: url(~@images/upload-add.png) center center no-repeat;
      border: none;
      padding: 0;
    }
  }

  .collect-img-row {
    .collect-img {
      position: relative;
      height: 270px;
      background: #f3f3f3;
      &.mini {
        height: 100px;
        .icon-close {
          right: 10px;
          top: 5px;
        }
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        // object-fit: contain;
      }
      .img-btn {
        width: 86px;
        position: absolute;
        bottom: 10px;
        left: 50%;
        border: none;
        text-align: center;
        margin-left: -43px;
      }
      .img-btn-first {
        background: #000;
        color: #ffffff;
        opacity: 0.5;
        width: 60px;
        margin-left: -30px;
      }
      .icon-close {
        position: absolute;
        right: 20px;
        top: 20px;
        z-index: 2;
        color: #0590ff;
        line-height: initial;
      }
    }
  }
}
</style>



